import React from "react";
import { AdvancedSettingsCard } from "./overview/AdvancedSettingsCard";
import { CacheKeepaliveCard } from "./overview/CacheKeepaliveCard";
import { DataRetentionCard } from "./overview/DataRetentionCard";
import { RoutingCard } from "./overview/RoutingCard";
import { SystemCacheTtlCard } from "./overview/SystemCacheTtlCard";
import { UsageThrottlingCard } from "./overview/UsageThrottlingCard";

export const SettingsTab = React.memo(() => {
	return (
		<div className="space-y-6">
			{/* Configuration Cards Grid */}
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
				<RoutingCard />
				<CacheKeepaliveCard />
				<SystemCacheTtlCard />
				<UsageThrottlingCard />
				<DataRetentionCard />
				<AdvancedSettingsCard />
			</div>
		</div>
	);
});
